import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validateRut } from '@fdograph/rut-utilities';

/**
 * Validador custom para el rut chileno
 * @returns
 */
export function customValidatorRut(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return { customError: 'El rut está vacio.' };
    }

    let cleanRut = value
      .replace(/[^0-9kK]+/g, '')
      .replace(/^0+/, '')
      .toUpperCase();

    if (!validateRut(cleanRut)) {
      return { customError: 'El rut es inválido.' };
    }
    return null;
  };
}

/**
 * Valida si el folio tiene el largo correcto dependiendo de su tipo (bipay, tne, default)
 * @param type tipo de folio a validar
 * @returns null o error con su mensaje correspondiente
 */
export function customValidatorFolio(type: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return { customError: 'El N° Folio está vacío' };
    }
    const valid =
      type === 'tarjeta'
        ? /^\d{8}$/.test(control.value)
        : type === 'tne'
        ? /^\d{5,15}$/.test(control.value)
        : /^\d{1,20}$/.test(control.value);
    return valid ? null : { customError: 'El N° Folio es inválido' };
  };
}

/**
 * Valida si los folios son iguales
 * @param firstKey primer formValue a comparar
 * @param secondKey segundo formValue a comparar
 * @returns null o error con su mensaje correspondiente
 */
export function matchFolios(firstKey: string, secondKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const firstControl = group.get(firstKey);
    const secondControl = group.get(secondKey);

    if (!firstControl || !secondControl) return null;
    if (!firstControl.value || !secondControl.value) return null;

    const match = firstControl.value === secondControl.value;
    return match ? null : { mismatchFolio: 'Los N° Folio no coinciden' };
  };
}

export default { customValidatorRut, customValidatorFolio, matchFolios };
